import { LoadingSpinner } from '@opengov/component-library/dist';
import { IOgGridTableProps, OgGridTable } from '@opengov/components-og-grid-table';

import React from 'react';

import { DataTableStatus } from '../../../../reportExplorer/types';

import { IReportLocale } from '../../../locale';

import styles from './ConditionalPreviewTable.scss';

export interface IConditionalPreviewTable {
  reportMessages: IReportLocale;
  conditionalPreviewTableStatus: DataTableStatus;
  conditionalPreviewTableProps: IOgGridTableProps;
}

export const ConditionalPreviewTable: React.FC<IConditionalPreviewTable> = (props) => {
  const { conditionalPreviewTableProps, conditionalPreviewTableStatus } = props;

  return conditionalPreviewTableStatus === DataTableStatus.Current &&
    conditionalPreviewTableProps.rowData.length > 0 ? (
    <OgGridTable {...conditionalPreviewTableProps} />
  ) : (
    <div className={styles.loadingWrapper}>
      <LoadingSpinner
        dataTest="data-table-updating-indicator"
        message={props.reportMessages.calculations.conditionalModal.loadingPreview}
      />
    </div>
  );
};
